import { render, staticRenderFns } from "./privacy.pug?vue&type=template&id=12bd1cb3&lang=pug&external"
import script from "./privacy.js?vue&type=script&lang=js&external"
export * from "./privacy.js?vue&type=script&lang=js&external"
import style0 from "./privacy.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12bd1cb3')) {
      api.createRecord('12bd1cb3', component.options)
    } else {
      api.reload('12bd1cb3', component.options)
    }
    module.hot.accept("./privacy.pug?vue&type=template&id=12bd1cb3&lang=pug&external", function () {
      api.rerender('12bd1cb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/privacyPolicy/index.vue"
export default component.exports